import { IdentityApi } from '@backstage/core-plugin-api';
import {
  AgenticMarketplaceRbacAuthorization,
  agenticMarketplaceReadPermission,
} from '@internal/backstage-plugin-agentic-marketplace-common';
import { AgenticMarketplaceApi, Permissions } from './AgenticMarketplaceApi';

export class AgenticMarketplaceClient implements AgenticMarketplaceApi {
  readonly #identityApi: IdentityApi;
  readonly #rbacAuth = new AgenticMarketplaceRbacAuthorization();

  constructor(options: { identityApi: IdentityApi }) {
    this.#identityApi = options.identityApi;
  }

  async checkPermissions(): Promise<Permissions> {
    const { token = '' } = await this.#identityApi.getCredentials();
    return {
      read: this.#rbacAuth.hasPermission(
        token,
        agenticMarketplaceReadPermission,
      ),
    };
  }
}
